import styled from '@emotion/styled'

export const V2L2ModalRoot = styled.div(({theme}) => ({
	border: `1px solid ${theme.colors.lines}`,
	borderRadius: theme.borderRadius,
	overflow: 'hidden',
	display: 'flex',
	flexDirection: 'column',
}))

export const V2L2SmallModalRoot = styled(V2L2ModalRoot)({
	flex: '0 1 38%',
	minWidth: '19rem',
})

export const V2L2LargeModalRoot = styled(V2L2ModalRoot)({
	flex: '0 1 68%',
	display: 'grid',
	gridTemplateRows: 'max-content 1fr max-content',
	height: 'calc(100vh - 240px)'
})
